import Route from 'cio/routes/base';
import { redirectIfViewer } from 'cio/utils/route-access';
import { inject as service } from '@ember/service';
import BillingService from 'cio/services/billing';
import Transition from '@ember/routing/-private/transition';

export default class WorkspaceSettingsRoute extends Route {
  @service billing!: BillingService;

  crumb() {
    let model = this.modelFor(this.routeName);

    return {
      name: 'Workspace settings',
      path: this.routeName,
      model,
      helpQuery: 'Workspace Settings',
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);
    await this.billing.initialize({ refresh: true, paramPlanSlug: '', code: '', ignoreErrors: true });
    return redirectIfViewer(this, transition);
  }
}
